// utils/scoringRules.js

export const POS = { DEF: "DEF", MID: "MID", FWD: "FWD" };

// 5-a-side scoring rules
export const RULES_5_A_SIDE = {
  appearance: 2,
  starter: 1,
  goal: {
    [POS.DEF]: 8,
    [POS.MID]: 7,
    [POS.FWD]: 7,
  },
  assist: 4,
  cleanSheet: {
    [POS.DEF]: 5,
    [POS.MID]: 3,
    [POS.FWD]: 2,
  },
  gksavebonus: 2,
  penaltysave: 5,
  yellowcard: -4,
  penaltymiss: -2,
  owngoal: -3,
  bonusByRank: { 1: 3, 2: 2, 3: 1 },
};

// 7-a-side scoring rules
export const RULES_7_A_SIDE = {
  appearance: 2,
  starter: 1,
  goal: {
    [POS.DEF]: 8,
    [POS.MID]: 7,
    [POS.FWD]: 7,
  },
  assist: 4,
  cleanSheet: {
    [POS.DEF]: 5,
    [POS.MID]: 3,
    [POS.FWD]: 2,
  },
  gksavebonus: 2,
  penaltysave: 5,
  yellowcard: -4,
  penaltymiss: -2,
  owngoal: -3,
  bonusByRank: { 1: 3, 2: 2, 3: 1 },
};

// 9-a-side scoring rules
export const RULES_9_A_SIDE = {
  appearance: 2,
  starter: 1,
  goal: {
    [POS.DEF]: 8,
    [POS.MID]: 7,
    [POS.FWD]: 7,
  },
  assist: 4,
  cleanSheet: {
    [POS.DEF]: 5,
    [POS.MID]: 3,
    [POS.FWD]: 2,
  },
  gksavebonus: 2,
  penaltysave: 5,
  yellowcard: -4,
  penaltymiss: -2,
  owngoal: -3,
  bonusByRank: { 1: 3, 2: 2, 3: 1 },
};

// 11-a-side scoring rules
export const RULES_11_A_SIDE = {
  appearance: 2,
  starter: 1,
  goal: {
    [POS.DEF]: 8,
    [POS.MID]: 7,
    [POS.FWD]: 7,
  },
  assist: 4,
  cleanSheet: {
    [POS.DEF]: 5,
    [POS.MID]: 3,
    [POS.FWD]: 2,
  },
  gksavebonus: 2,
  penaltysave: 5,
  yellowcard: -4,
  penaltymiss: -2,
  owngoal: -3,
  bonusByRank: { 1: 3, 2: 2, 3: 1 },
};

// Canonical keys for infractions and their user-friendly labels
export const CANON_TO_LABEL = {
  yellowcard: "Yellow Card",
  owngoal: "Own Goal",
  penaltymiss: "Penalty Miss",
  gksavebonus: "GK 3+ Save Bonus",
  penaltysave: "Penalty Save",
};

// Canonical keys mapped to their point values (from 11-a-side RULES)
export const CANON_INFRACTIONS = {
  yellowcard: RULES_11_A_SIDE.yellowcard,
  owngoal: RULES_11_A_SIDE.owngoal,
  penaltymiss: RULES_11_A_SIDE.penaltymiss,
  gksavebonus: RULES_11_A_SIDE.gksavebonus,
  penaltysave: RULES_11_A_SIDE.penaltysave,
};

// Map league sizes to their rulesets
export const LEAGUE_RULESETS = {
  "5": RULES_5_A_SIDE,
  "7": RULES_7_A_SIDE,
  "9": RULES_9_A_SIDE,
  "11": RULES_11_A_SIDE,
};

// Map canonical keys to their point values (from 11-a-side RULES)
export const INFRACTION_POINTS = {
  yellowcard: RULES_11_A_SIDE.yellowcard,
  penaltymiss: RULES_11_A_SIDE.penaltymiss,
  penaltysave: RULES_11_A_SIDE.penaltysave,
  owngoal: RULES_11_A_SIDE.owngoal,
  gksavebonus: RULES_11_A_SIDE.gksavebonus,
};

const scoringRules = {
  POS,
  RULES_5_A_SIDE,
  RULES_7_A_SIDE,
  RULES_9_A_SIDE,
  RULES_11_A_SIDE,
  CANON_TO_LABEL,
  CANON_INFRACTIONS,
  LEAGUE_RULESETS,
  INFRACTION_POINTS,
};

export default scoringRules;